import { c as r } from "../clsx-OuTLNxxd.js";
import { t } from "../bundle-mjs-DoW15_-f.js";
const s = (...o) => t(r(...o));
export {
  s as cn
};
